module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bc-spec-mall"
  }, [_c('div', {
    staticClass: "bc-spec-mall__inner"
  }, [_c('h1', {
    staticClass: "bc-spec-mall__title"
  }, [_vm._v(_vm._s(_vm.$T('观众中心商城标题')))]), _vm._v(" "), _c('p', {
    staticClass: "bc-spec-mall__desc"
  }, [_vm._v(_vm._s(_vm.$T('观众中心商城说明')))]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "bc-spec-mall__empty"
  }, [_vm._v(_vm._s(_vm.$T('观众中心加载中')))]) : (!_vm.list.length) ? _c('div', {
    staticClass: "bc-spec-mall__empty"
  }, [_vm._v(_vm._s(_vm.$T('观众中心暂无商品')))]) : _c('div', {
    staticClass: "bc-spec-mall__grid"
  }, _vm._l((_vm.list), function(item) {
    return _c('a', {
      key: item.id,
      staticClass: "bc-spec-mall__card",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.goDetail(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "bc-spec-mall__pic-wrap"
    }, [_c('img', {
      staticClass: "bc-spec-mall__pic",
      attrs: {
        "src": item.pic_url,
        "alt": _vm.goodsTitle(item)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "bc-spec-mall__meta"
    }, [_c('h2', {
      staticClass: "bc-spec-mall__name"
    }, [_vm._v(_vm._s(_vm.goodsTitle(item)))]), _vm._v(" "), _c('p', {
      staticClass: "bc-spec-mall__price"
    }, [_vm._v(_vm._s(_vm.money(_vm.priceText(item))))])])])
  }), 0), _vm._v(" "), (_vm.totalpage > 1) ? _c('div', {
    staticClass: "bc-spec-mall__pager"
  }, [_c('button', {
    staticClass: "bc-spec-mall__page-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.p <= 1
    },
    on: {
      "click": function($event) {
        return _vm.loadPage(_vm.p - 1)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$T('观众中心上一页')) + "\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "bc-spec-mall__page-num"
  }, [_vm._v(_vm._s(_vm.p) + " / " + _vm._s(_vm.totalpage))]), _vm._v(" "), _c('button', {
    staticClass: "bc-spec-mall__page-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.p >= _vm.totalpage
    },
    on: {
      "click": function($event) {
        return _vm.loadPage(_vm.p + 1)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$T('观众中心下一页')) + "\n      ")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76de3e59","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/mainindex/SpectatorMall.vue
// module id = 1525
// module chunks = 0